// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Terms of Service Page Styles */
.TermsOfService_main__eSrJp {
  min-height: 100vh;
  background-color: var(--color-bg);
  padding: 40px 24px 80px;
}

.TermsOfService_container__N84zf {
  max-width: 800px;
  margin: 0 auto;
}

/* Back Button */
.TermsOfService_backButton__bO95h {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  color: var(--color-text-muted);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 32px;
}

.TermsOfService_backButton__bO95h:hover {
  background-color: var(--color-bg-panel);
  color: var(--color-text);
  border-color: rgba(141, 160, 216, 0.3);
}

/* Header */
.TermsOfService_header__4jH-e {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid var(--color-border);
}

.TermsOfService_headerIcon__eh552 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, rgba(141, 160, 216, 0.15), rgba(141, 160, 216, 0.05));
  border: 1px solid rgba(141, 160, 216, 0.2);
  border-radius: 16px;
  margin-bottom: 20px;
  color: var(--color-accent);
}

.TermsOfService_header__4jH-e h1 {
  font-size: 32px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0 0 12px;
}

.TermsOfService_lastUpdated__pFTio {
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 0;
}

/* Notice Box */
.TermsOfService_noticeBox__-N8eU {
  display: flex;
  gap: 16px;
  padding: 20px;
  background-color: rgba(234, 179, 8, 0.08);
  border: 1px solid rgba(234, 179, 8, 0.2);
  border-radius: 12px;
  margin-bottom: 32px;
}

.TermsOfService_noticeBox__-N8eU svg {
  flex-shrink: 0;
  color: #eab308;
  margin-top: 2px;
}

.TermsOfService_noticeBox__-N8eU strong {
  display: block;
  font-size: 15px;
  color: var(--color-text);
  margin-bottom: 6px;
}

.TermsOfService_noticeBox__-N8eU p {
  font-size: 14px;
  color: var(--color-text-muted);
  line-height: 1.6;
  margin: 0;
}

/* Table of Contents */
.TermsOfService_toc__JWsyh {
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 40px;
}

.TermsOfService_toc__JWsyh h2 {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 16px;
}

.TermsOfService_toc__JWsyh ol {
  margin: 0;
  padding-left: 20px;
  columns: 2;
  column-gap: 32px;
}

@media (max-width: 600px) {
  .TermsOfService_toc__JWsyh ol {
    columns: 1;
  }
}

.TermsOfService_toc__JWsyh li {
  font-size: 14px;
  padding: 4px 0;
  page-break-inside: avoid;
  break-inside: avoid;
}

.TermsOfService_toc__JWsyh a {
  color: var(--color-text-muted);
  text-decoration: none;
  transition: color 0.15s;
}

.TermsOfService_toc__JWsyh a:hover {
  color: var(--color-accent);
}

/* Content */
.TermsOfService_content__g9gbQ {
  color: var(--color-text);
}

.TermsOfService_section__Ud34F {
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid var(--color-border);
}

.TermsOfService_section__Ud34F:last-child {
  border-bottom: none;
}

.TermsOfService_section__Ud34F h2 {
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 16px;
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.TermsOfService_sectionNumber__s9Dke {
  color: var(--color-accent);
  font-weight: 700;
}

.TermsOfService_section__Ud34F h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
  margin: 24px 0 12px;
}

.TermsOfService_section__Ud34F p {
  font-size: 15px;
  line-height: 1.7;
  color: var(--color-text-muted);
  margin: 0 0 16px;
}

.TermsOfService_section__Ud34F ul {
  margin: 0 0 16px;
  padding-left: 24px;
}

.TermsOfService_section__Ud34F li {
  font-size: 15px;
  line-height: 1.7;
  color: var(--color-text-muted);
  margin-bottom: 8px;
}

.TermsOfService_section__Ud34F strong {
  color: var(--color-text);
}

/* Critical Sections (Not Financial Advice, Risk) */
.TermsOfService_criticalSection__4qVZ1 {
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 24px;
}

.TermsOfService_criticalSection__4qVZ1 h2 {
  margin-bottom: 20px;
}

.TermsOfService_criticalContent__yImuC {
  display: flex;
  gap: 16px;
}

.TermsOfService_criticalContent__yImuC svg {
  flex-shrink: 0;
  color: #ef4444;
  margin-top: 4px;
}

.TermsOfService_criticalContent__yImuC p:first-of-type {
  font-size: 16px;
  color: var(--color-text);
  margin-bottom: 12px;
}

@media (max-width: 600px) {
  .TermsOfService_criticalContent__yImuC {
    flex-direction: column;
  }
}

/* Contact Box */
.TermsOfService_contactBox__qRtNn {
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 16px 20px;
  margin-top: 16px;
}

.TermsOfService_contactBox__qRtNn p {
  margin: 0 0 4px;
  font-size: 14px;
}

.TermsOfService_contactBox__qRtNn p:last-child {
  margin-bottom: 0;
}

/* Acknowledgment */
.TermsOfService_acknowledgment__03kre {
  display: flex;
  gap: 16px;
  padding: 24px;
  background: linear-gradient(135deg, rgba(141, 160, 216, 0.1), rgba(141, 160, 216, 0.02));
  border: 1px solid rgba(141, 160, 216, 0.2);
  border-radius: 12px;
  margin: 40px 0;
}

.TermsOfService_acknowledgment__03kre svg {
  flex-shrink: 0;
  color: var(--color-accent);
  margin-top: 2px;
}

.TermsOfService_acknowledgment__03kre p {
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-text-muted);
  margin: 0;
}

/* Back to Top */
.TermsOfService_backToTop__GBakF {
  text-align: center;
}

.TermsOfService_backToTop__GBakF button {
  padding: 12px 24px;
  background-color: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  color: var(--color-text-muted);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
}

.TermsOfService_backToTop__GBakF button:hover {
  background-color: var(--color-bg-panel);
  color: var(--color-text);
}
`, "",{"version":3,"sources":["webpack://./src/components/TermsOfService.module.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yFAAyF;EACzF,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yCAAyC;EACzC,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mDAAmD;AACnD;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,gBAAgB;AAChB;EACE,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,wFAAwF;EACxF,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B","sourcesContent":["/* Terms of Service Page Styles */\n.main {\n  min-height: 100vh;\n  background-color: var(--color-bg);\n  padding: 40px 24px 80px;\n}\n\n.container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n/* Back Button */\n.backButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  color: var(--color-text-muted);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.15s;\n  margin-bottom: 32px;\n}\n\n.backButton:hover {\n  background-color: var(--color-bg-panel);\n  color: var(--color-text);\n  border-color: rgba(141, 160, 216, 0.3);\n}\n\n/* Header */\n.header {\n  text-align: center;\n  margin-bottom: 40px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.headerIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  background: linear-gradient(135deg, rgba(141, 160, 216, 0.15), rgba(141, 160, 216, 0.05));\n  border: 1px solid rgba(141, 160, 216, 0.2);\n  border-radius: 16px;\n  margin-bottom: 20px;\n  color: var(--color-accent);\n}\n\n.header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--color-text);\n  margin: 0 0 12px;\n}\n\n.lastUpdated {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  margin: 0;\n}\n\n/* Notice Box */\n.noticeBox {\n  display: flex;\n  gap: 16px;\n  padding: 20px;\n  background-color: rgba(234, 179, 8, 0.08);\n  border: 1px solid rgba(234, 179, 8, 0.2);\n  border-radius: 12px;\n  margin-bottom: 32px;\n}\n\n.noticeBox svg {\n  flex-shrink: 0;\n  color: #eab308;\n  margin-top: 2px;\n}\n\n.noticeBox strong {\n  display: block;\n  font-size: 15px;\n  color: var(--color-text);\n  margin-bottom: 6px;\n}\n\n.noticeBox p {\n  font-size: 14px;\n  color: var(--color-text-muted);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Table of Contents */\n.toc {\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 24px 28px;\n  margin-bottom: 40px;\n}\n\n.toc h2 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 16px;\n}\n\n.toc ol {\n  margin: 0;\n  padding-left: 20px;\n  columns: 2;\n  column-gap: 32px;\n}\n\n@media (max-width: 600px) {\n  .toc ol {\n    columns: 1;\n  }\n}\n\n.toc li {\n  font-size: 14px;\n  padding: 4px 0;\n  break-inside: avoid;\n}\n\n.toc a {\n  color: var(--color-text-muted);\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.toc a:hover {\n  color: var(--color-accent);\n}\n\n/* Content */\n.content {\n  color: var(--color-text);\n}\n\n.section {\n  margin-bottom: 40px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.section:last-child {\n  border-bottom: none;\n}\n\n.section h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 0 0 16px;\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.sectionNumber {\n  color: var(--color-accent);\n  font-weight: 700;\n}\n\n.section h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text);\n  margin: 24px 0 12px;\n}\n\n.section p {\n  font-size: 15px;\n  line-height: 1.7;\n  color: var(--color-text-muted);\n  margin: 0 0 16px;\n}\n\n.section ul {\n  margin: 0 0 16px;\n  padding-left: 24px;\n}\n\n.section li {\n  font-size: 15px;\n  line-height: 1.7;\n  color: var(--color-text-muted);\n  margin-bottom: 8px;\n}\n\n.section strong {\n  color: var(--color-text);\n}\n\n/* Critical Sections (Not Financial Advice, Risk) */\n.criticalSection {\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 24px;\n}\n\n.criticalSection h2 {\n  margin-bottom: 20px;\n}\n\n.criticalContent {\n  display: flex;\n  gap: 16px;\n}\n\n.criticalContent svg {\n  flex-shrink: 0;\n  color: #ef4444;\n  margin-top: 4px;\n}\n\n.criticalContent p:first-of-type {\n  font-size: 16px;\n  color: var(--color-text);\n  margin-bottom: 12px;\n}\n\n@media (max-width: 600px) {\n  .criticalContent {\n    flex-direction: column;\n  }\n}\n\n/* Contact Box */\n.contactBox {\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-top: 16px;\n}\n\n.contactBox p {\n  margin: 0 0 4px;\n  font-size: 14px;\n}\n\n.contactBox p:last-child {\n  margin-bottom: 0;\n}\n\n/* Acknowledgment */\n.acknowledgment {\n  display: flex;\n  gap: 16px;\n  padding: 24px;\n  background: linear-gradient(135deg, rgba(141, 160, 216, 0.1), rgba(141, 160, 216, 0.02));\n  border: 1px solid rgba(141, 160, 216, 0.2);\n  border-radius: 12px;\n  margin: 40px 0;\n}\n\n.acknowledgment svg {\n  flex-shrink: 0;\n  color: var(--color-accent);\n  margin-top: 2px;\n}\n\n.acknowledgment p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--color-text-muted);\n  margin: 0;\n}\n\n/* Back to Top */\n.backToTop {\n  text-align: center;\n}\n\n.backToTop button {\n  padding: 12px 24px;\n  background-color: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  color: var(--color-text-muted);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.backToTop button:hover {\n  background-color: var(--color-bg-panel);\n  color: var(--color-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `TermsOfService_main__eSrJp`,
	"container": `TermsOfService_container__N84zf`,
	"backButton": `TermsOfService_backButton__bO95h`,
	"header": `TermsOfService_header__4jH-e`,
	"headerIcon": `TermsOfService_headerIcon__eh552`,
	"lastUpdated": `TermsOfService_lastUpdated__pFTio`,
	"noticeBox": `TermsOfService_noticeBox__-N8eU`,
	"toc": `TermsOfService_toc__JWsyh`,
	"content": `TermsOfService_content__g9gbQ`,
	"section": `TermsOfService_section__Ud34F`,
	"sectionNumber": `TermsOfService_sectionNumber__s9Dke`,
	"criticalSection": `TermsOfService_criticalSection__4qVZ1`,
	"criticalContent": `TermsOfService_criticalContent__yImuC`,
	"contactBox": `TermsOfService_contactBox__qRtNn`,
	"acknowledgment": `TermsOfService_acknowledgment__03kre`,
	"backToTop": `TermsOfService_backToTop__GBakF`
};
export default ___CSS_LOADER_EXPORT___;
